import { ButtonGroupWrapper, FilledButton, OutlinedButton } from "@sainsburys-tech/luna-button"
import { FC } from "react"
import { ActionButtonProps } from "../../Types/ActionButtonProps"
import { consolelog } from "../../helpers/consolelog"

const ActionButton: FC<ActionButtonProps> = (props) => {
  consolelog('Action', JSON.stringify(props))
  return (
    <>
      <div className="ln-u-bg-color-white stickyButtonGroup">
        <ButtonGroupWrapper className="duButtonGroup">
          <OutlinedButton className="duButtonGroup-add"
            onClick={(event) => props.onCancel()} type="button">
            Cancel
          </OutlinedButton>
          <FilledButton className="duButtonGroup-add" type="button" disabled={props.isAddDisabled}
            onClick={(event) => props.onSubmit(event)}>
            Save
          </FilledButton>
          {props.isClearButtonRequired && <OutlinedButton className="duButtonGroup-add" disabled={!props.isDirty}
            onClick={(event) => props.onClearAll(event)} type="button">
            {props.isEdit ? "Reset" : "Clear All"}
          </OutlinedButton>}
        </ButtonGroupWrapper>
      </div>
    </>
  )
}

export default ActionButton